export default __webpack_public_path__ + "static/media/special.04c668f3.png";